import React from 'react'
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function OverlayTriggerComponent({
  text = "",
  placement = "top",
  children,
}) {
  return (
    <OverlayTrigger
      trigger={["hover", "focus"]}
      key={placement}
      delay={{ show: 1, hide: 1 }}
      placement={placement}
      overlay={
        <Tooltip className="option_popover ">
          {text}
        </Tooltip>
      }>
      {children}
    </OverlayTrigger>
  )
}
